import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getCause } from "../../store/actions/causes_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/causes_enum";
import SingleView from "../../components/common/SingleView";
const ViewCause = ({ getCause, match, cause: { loading, cause } }) => {
  useEffect(() => {
    getCause(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Causes"
          mainLinkTitle="Causes"
          mainLinkUrl="/causes"
          activeLink="View"
        />
        {!loading ? (
          cause && (
            <SingleView
              data={cause}
              inputFields={inputFields}
              label="Cause"
              link="causes"
              id={cause.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ cause: state.cause });

const mapDispatchToProps = { getCause };

export default connect(mapStateToProps, mapDispatchToProps)(ViewCause);
